<template>
    <div>
        <div class="search-box">
            <input type="text" v-model="searchText" @keyup.enter="searchLocation" placeholder="输入地点进行搜索">
            <button @click="searchLocation">搜索</button>
            <div class="search-results" v-if="searchResults.length > 0">
                <div v-for="(result, index) in searchResults" :key="index" @click="selectSearchResult(result)">
                    {{ result.address }}
                </div>
            </div>
        </div>
        <div class="map" :id="id">
            <div class="status">
                <div><span>{{ status }}</span><a @click="forceReload();">{{ reloadbtn }}</a></div>
            </div>
        </div>
    </div>
</template>

<script>
/* eslint-disable no-undef */
import trans from '@/common/geo'
// import Config from '@/base/config'
import axios from 'axios'
console.log(trans)
const geo = {
    trans: trans
}
const Config = {
    MapDefaultData: {
        center_lng: 102.84253606960299,
        center_lat: 24.841920226301035,
        zoom: 16
    }
}

let _id = 0;
function nextId() {
    return new String(++_id);
}

class Linear {
    constructor(frame) {
        this.last = null;
        this.values = [];
        this.frame = frame || 10;
    }

    pop() {
        var v = this.values.shift();
        return v;
    }

    push(v, count) {
        // console.log('push', v)
        if (this.last === null) {
            this.last = v;
            this.values.push(v);
        }
        else {
            // 线性插值
            var icount = count || this.frame;
            var k = (v - this.last) * 1.0 / icount;
            for (let i = 0; i < icount; ++i) {
                this.values.push(this.last + k * (i + 1));
            }
            this.last = v;
        }
    }

    clear() {
        this.values.splice(0, this.values.length);
    }
}

class LinearLngLat {
    constructor() {
        this.lngp = new Linear();
        this.latp = new Linear();
    }

    pop() {
        var lng = this.lngp.pop();
        var lat = this.latp.pop();
        return lng !== undefined && lat !== undefined ? [lng, lat] : null;
    }

    push(lng, lat, count) {
        this.lngp.push(lng, count);
        this.latp.push(lat, count);
    }

    clear() {
        this.lngp.clear();
        this.latp.clear();
    }
}

var markerMap = {
    // 需要用到的marker在这里声明
    default: {
        icon: require('@/assets/map/default-mark.svg'),
        size: [27, 36],
        anchor: [17, 33.3],
    },
}
var MapConfig = {
    // MarkerMoveTimeTicks: 100,
    MarkerMoveFrame: 20,    // 每秒帧数
};

var wrapMarker = function (marker) {
    if (!marker.move) {
        // 修饰move方法
        var move = function (lng, lat) {
            var _move = marker._move;
            if (!_move) {
                _move = {
                    val: new LinearLngLat(MapConfig.MarkerMoveFrame),
                    next() {
                        var lngat = marker._move.val.pop();
                        if (lngat != null) {
                            marker.setPosition(lngat[0], lngat[1], true);
                        }
                        else {
                            _move.clear();
                        }
                        return lngat;
                    },
                    push(lng, lat) {
                        if (_move.lasttime) {
                            var now = Date.now();
                            var timeoff = now - _move.lasttime;
                            var count = Math.max(1, Math.floor(timeoff / 1000.0 * MapConfig.MarkerMoveFrame));   // 插值数量
                            _move.val.push(lng, lat, count);
                        }
                        else {
                            _move.val.push(lng, lat);
                        }
                        _move.lasttime = Date.now();
                    },
                    clear() {
                        // clearInterval(_move.timer);
                        // _move.timer = 0;
                        // _move.val.clear();
                    }
                }
                marker._move = _move;
            }
            _move.push(lng, lat);
            if (!wrapMarker.timer) {
                // _move.next();
                // _move.lasttime = Date.now();
                wrapMarker.markers = [];
                wrapMarker.timer = setInterval(function () {
                    wrapMarker.markers.map(mk => {
                        if (mk._move.lasttime) {
                            mk._move.next();
                        }
                    });

                }, 1000.0 / MapConfig.MarkerMoveFrame);
            }
            else if (!wrapMarker.markers.includes(marker)) {
                wrapMarker.markers.push(marker)
            }
            if (!_move.lasttime)
                _move.next();
        };
        marker.move = function (lng, lat) {
            move.call(marker, lng, lat);
        }

        var _setPoint = marker.setPosition;
        marker.setPosition = function (lng, lat, ismove) {
            _setPoint.call(marker, lng, lat);
            if (!ismove && marker._move) {
                marker._move.lasttime = 0;
            }
        }
    }
    return marker;
}

class BaseMap {
    centerAndZoom(lng, lat, zoom) {
        this.center(lng, lat);
    }

    defaultData = Config.MapDefaultData

    addEventListener(eventname, callback) {
        // 添加事件
        // 支持:
        // 1. 单击: click,  callback({lng,lat})
        // 2. 拖动: dragend
        // 3.
    }

    removeEventListen(eventholder) {
        this.map.removeEventListener(eventholder[0], eventholder[1]);
    }

    move(lng, lat) {
        this.center(lng, lat);
    }
}

class BaiduMap extends BaseMap {
    constructor(containid) {
        super(containid);
        this.ak = 'S2bCbdNkSLHIzfXmfgax5yZGdxzfMOkO';
        this.maptype = 'bmap';
        this.map = new BMap.Map(containid, {
            enableMapClick: false
        });
        this.map.addControl(new BMap.ScaleControl());
        this.map.addControl(new BMap.NavigationControl());
    }

    getPoint(lng, lat) {
        // 转换为百度点
        var bd09 = geo.trans.wgs84tobd09(lng, lat);
        return new BMap.Point(bd09[0], bd09[1]);
    }

    revPoint(pt) {
        // 从百度地图点位逆向转换为[lng, lat]
        var wgs84 = geo.trans.bd09towgs84(pt.lng, pt.lat);
        return wgs84;
    }

    // 对外方法
    centerAndZoom(lng, lat, zoom) {
        this.map.centerAndZoom(this.getPoint(lng, lat), zoom)
    }

    center(lng, lat) {
        this.map.centerAndZoom(this.getPoint(lng, lat), this.map.getZoom())
    }

    zoom(zoom) {
        this.map.setZoom(zoom)
    }

    getZoom() {
        return this.map.getZoom()
    }

    getCenter() {
        return this.revPoint(this.map.getCenter())
    }

    getStatus() {
        var bds = this.map.getBounds();
        return {
            bounds: [bds.Le, bds.Ge, bds.Ke, bds.Fe],
            center: this.getCenter(),
            zoom: this.getZoom()
        }
    }

    setDisabled(bool) {
        if (bool) {
            this.map.disableDragging();
            this.map.disableScrollWheelZoom();
        }
        else {
            this.map.enableDragging();
            this.map.enableScrollWheelZoom();
        }
    }

    // --Marker
    addMarker(lng, lat, options) {
        var thiz = this;
        var markeropt = {};
        if (!options)
            options = {};
        if (!options.type)
            options.type = 'default';
        if (options && options.type in markerMap) {
            var markopt = markerMap[options.type];
            markeropt.icon = new BMap.Icon(markopt.icon, new BMap.Size(markopt.size[0], markopt.size[1]), {
                anchor: new BMap.Size(markopt.anchor[0], markopt.anchor[1]),
            });
        }
        var marker = new BMap.Marker(this.getPoint(lng, lat), markeropt);
        this.map.addOverlay(marker);
        var map = this.map;
        var wrapmarker = {
            marker: marker,
            setPosition(lng, lat) {
                this.marker.setPosition(thiz.getPoint(lng, lat));
            },
            remove() {
                thiz.map.removeOverlay(this.marker);
            },
        };
        wrapmarker = wrapMarker(wrapmarker);
        return wrapmarker;
    }

    removeMarker(wrapmarker) {
        this.map.removeOverlay(wrapmarker.marker);
    }

    // --END Marker

    // 事件
    eventMapping = {}

    addEventListener(eventname, callback) {
        var thiz = this;
        var wrapcbk = callback;
        if (eventname === 'click') {
            wrapcbk = function (e) {
                // console.log(eventname, e);
                var lngat = thiz.revPoint(e.point);
                callback && callback.call(thiz, { lng: lngat[0], lat: lngat[1], map: thiz, e: e });
            };
        }
        else {
            wrapcbk = function (e) {
                // console.log(eventname, e);
                callback && callback.call(thiz, { map: thiz, e: e });
            };
        }
        var realevetnname = this.eventMapping[eventname] || eventname;
        this.map.addEventListener(realevetnname, wrapcbk);
        return [realevetnname, wrapcbk];
    }

    removeEventListen(eventholder) {
        this.map.removeEventListener(eventholder[0], eventholder[1]);
    }

    // END事件

    clearMarkers() {
        this.map.clearOverlays();
    }

    // END对外方法

    clearRoute() {
        if (this.drivingRoute)
            this.drivingRoute.clearResults();
    }

    displayRoute(option, callback) {
        var thiz = this;
        if (!this.drivingRoute) {
            this.drivingRoute = new BMap.DrivingRoute(this.map, {
                renderOptions: {
                    map: this.map,
                    autoViewport: true,
                },
            });
        }
        if (!option.keeyMarkers)
            this.clearMarkers();
        this.drivingRoute.clearResults();
        this.drivingRoute.setSearchCompleteCallback(function (res) {
            console.log(res)
            callback && callback({
                distance: res.taxiFare ? res.taxiFare.distance : 0,
                duration: res.taxiFare ? res.taxiFare.distance / 1000 / 50 * 60 : 0,
            });
        });
        var start = this.getPoint(option.dep.longitude, option.dep.latitude);
        var end = this.getPoint(option.des.longitude, option.des.latitude);
        this.drivingRoute.search(start, end, {
            waypoints: option.waypoints ? option.waypoints.map(function (p) {
                return thiz.getPoint(p.longitude, p.latitude);
            }) : null,
        });
    }

    geocode(option, callback) {
        // 解析经纬度到地址
        var thiz = this;
        if (option.location) {
            // 解析经纬度
            var geocoder = new BMap.Geocoder();
            var goption = {};
            geocoder.getLocation(this.getPoint(option.location[0], option.location[1]), function (res) {
                var result = null;
                if (res) {
                    console.log(res);
                    var ac = res.addressComponents;
                    result = [{
                        address: res.address,
                        components: [ac.province, ac.city, ac.district, ac.street, ac.streetNumber].filter(function (c) {
                            return c;
                        }).map(function (c) {
                            return { name: c }
                        }),
                        location: thiz.revPoint(res.point)
                    }];
                }
                callback && callback.call(thiz, result);
            });
        }
        else {
            // 解析名称
            var local = new BMap.LocalSearch(this.map, {
                onSearchComplete(res) {
                    // console.log(res.getCurrentNumPois());
                    var result = null;
                    if (res) {
                        var pois = [];
                        for (var i = 0; i < res.getCurrentNumPois(); i++) {
                            pois.push(res.getPoi(i))
                        }
                        console.log(pois);
                        result = pois.map(function (t) {
                            return {
                                address: t.title,
                                components: [t.province, t.city].map(function (n) {
                                    return n;
                                }).filter(function (n) {
                                    return n;
                                }),
                                location: thiz.revPoint(t.point)
                            }
                        });
                    }
                    callback && callback.call(thiz, result);
                }
            });
            local.search(option.address, { forceLocal: true });
        }
    }

    /*  返回多点之间的距离和时间
        @dep:[{lng,lat},...]
        @des:[{lng,lat},...]
    */
    distancematrix(options, callback) {
        let thiz = this;
        let time_gap = localStorage.getItem('_distancematrix_time') || 0;
        //不支持跨域调用
        let url = 'https://api.map.baidu.com/routematrix/v2/driving?output=json';
        //更新频率5分钟
        if (time_gap && (time_gap - Date.now()) / 1000 / 60 < 5) return;
        localStorage.setItem('_distancematrix_time', Date.now());
        let origins, destinations;
        ['dep', 'des'].map(function (type) {
            let tmp = '';
            options[type].map(function (v, index) {
                let point = thiz.getPoint(v.longitude, v.latitude);
                tmp += point.lat + ',' + point.lng;
                if (index + 1 != options.dep.length) tmp += '|';
            });
            if (type == 'dep') {
                origins = tmp;
            } else {
                destinations = tmp;
            }
        });
        axios.get(url, {
            params: {
                ak: this.ak,
                origins: origins,
                destinations: destinations
            },
            headers: {
                "Access-Control-Allow-Origin": "*",
            },
            withCredentials: true
        }).then(res => {
            debugger;
        }).catch(res => {
            console.log(res);
        });
        // if(status)callback(res.rows[0] && res.rows[0].elements[0] && res.rows[0].elements[0]);
    }

    //
}

class GoogleMap extends BaseMap {
    constructor(containid) {
        super(containid);
        var data = this.defaultData;
        this.maptype = 'gmap';
        this.map = new google.maps.Map(document.getElementById(containid), {
            zoom: data.zoom,
            // center: this.getPoint(data.center_lng, data.center_lat),
            disableDefaultUI: true,
            scaleControl: true,
            zoomControl: true,
            clickableIcons: false,
        });
    }

    getPoint(lng, lat) {
        // 转换为GMap点
        if (geo.trans.out_of_china(lng, lat)) {
            return { lng: lng, lat: lat };
        }
        else {
            var gcj02 = geo.trans.wgs84togcj02(lng, lat);
            return { lng: gcj02[0], lat: gcj02[1] };
        }
    }

    revPoint(pt) {
        // 从GMap点位逆向转换为[lng, lat]
        if (geo.trans.out_of_china(pt.lng, pt.lat)) {
            return [pt.lng, pt.lat];
        }
        else {
            var wgs84 = geo.trans.gcj02towgs84(pt.lng, pt.lat);
            return wgs84;
        }
    }

    // 对外方法
    center(lng, lat) {
        this.map.setCenter(this.getPoint(lng, lat))
    }

    getCenter() {
        var center = this.map.getCenter();
        return this.revPoint({ lng: center.lng(), lat: center.lat() });
    }

    zoom(zoom) {
        this.map.setZoom(zoom)
    }

    getZoom() {
        return this.map.getZoom()
    }

    // 对外方法
    centerAndZoom(lng, lat, zoom) {
        this.center(lng, lat);
        this.zoom(zoom);
    }

    // --Marker
    wrapmarkers = []

    addMarker(lng, lat, options) {
        var thiz = this;
        var goptions = {
            position: this.getPoint(lng, lat),
            map: this.map,
        };
        if (!options)
            options = {};
        if (!options.type)
            options.type = 'default';
        if (options && options.type in markerMap) {
            var markopt = markerMap[options.type];
            goptions.icon = markopt.icon;
            goptions.anchor = new google.maps.Point(markopt.anchor[0], markopt.anchor[1])
        }
        var marker = new google.maps.Marker(goptions);
        var wrapmarker = {
            marker: marker,
            setPosition(lng, lat) {
                this.marker.setPosition(thiz.getPoint(lng, lat))
            },
            remove() {
                this.marker.setMap(null);
            },
        };
        wrapmarker = wrapMarker(wrapmarker);
        this.wrapmarkers.push(wrapmarker);
        return wrapmarker;
    }

    removeMarker(wrapmarker) {
        wrapmarker.remove();
    }

    clearMarkers() {
        this.wrapmarkers.map(mk => {
            mk.remove();
        });
        this.wrapmarkers = [];
    }

    getStatus() {
        var bds = this.map.getBounds();
        return bds ? {
            bounds: [bds.b.b, bds.b.f, bds.f.b, bds.f.f],
            center: this.getCenter(),
            zoom: this.getZoom()
        } : null;
    }

    setDisabled(bool) {
        this.map.setOptions({
            draggable: !bool,
            zoomControl: !bool,
            scrollwheel: !bool,
            disableDoubleClickZoom: bool
        });
    }

    // 事件
    eventMapping = {}

    addEventListener(eventname, callback) {
        var thiz = this;
        var wrapcbk = callback;
        if (eventname === 'click') {
            wrapcbk = function (e) {
                // console.log(eventname, e);
                var lngat = thiz.revPoint({ lng: e.latLng.lng(), lat: e.latLng.lat(), map: thiz, e: e });
                callback && callback.call(thiz, { lng: lngat[0], lat: lngat[1] });
            };
        }
        else {
            wrapcbk = function (e) {
                // console.log(eventname, e);
                callback && callback.call(thiz, { map: thiz, e: e });
            };
        }
        var handler = google.maps.event.addListener(this.map, this.eventMapping[eventname] || eventname, wrapcbk);
        return handler;
    }

    removeEventListen(eventholder) {
        google.maps.event.removeListener(handler);
    }

    // END 事件

    geocode(option, callback) {
        // 解析经纬度到地址
        var thiz = this;
        var goption = {};
        if (option.location) {
            goption.location = this.getPoint(option.location[0], option.location[1]);
        }
        else {
            goption.address = option.address;
            goption.bounds = this.map.getBounds();
        }
        if (option.location) {
            // 解析经纬度
            var geocoder = new google.maps.Geocoder();
            geocoder.geocode(goption, function (results, status) {
                console.log(results, status)
                var result = null;
                if (results && results.length) {
                    var components = [];
                    var res = results[0];
                    res.address_components.map(function (r) {
                        components.push({
                            name: r.long_name
                        });
                    })
                    components.reverse();
                    var loc = res.geometry.location;
                    result = [{
                        address: res.formatted_address,
                        components: components,
                        location: thiz.revPoint({ lng: loc.lng(), lat: loc.lat() })
                    }]
                }
                callback && callback.call(thiz, result);
            });
        }
        else {
            // 解析名称
            var request = {
                location: this.map.getCenter(),
                radius: '50000',
                keyword: option.address
            };
            if (!this.placesService) {
                this.placesService = new google.maps.places.PlacesService(this.map);
            }
            // var service = new google.maps.places.PlacesService(this.map);
            this.placesService.nearbySearch(request, function (results, status) {
                console.log(results, status);
                var result = (results || []).map(function (r) {
                    return {
                        address: r.name,
                        components: [],
                        location: thiz.revPoint({ lng: r.geometry.location.lng(), lat: r.geometry.location.lat() }),
                    };
                });
                callback && callback.call(thiz, result);
            });
        }
    }

    clearRoute() {
        if (this.directionsDisplay) {
            this.directionsDisplay.setMap(null);
        }
    }

    displayRoute(option, callback) {
        // 显示路径
        // console.log(option)
        var thiz = this;
        if (!this.directionsDisplay) {
            this.directionsDisplay = new google.maps.DirectionsRenderer;
            this.directionsService = new google.maps.DirectionsService;
        }
        this.directionsDisplay.setMap(this.map);
        if (!option.keeyMarkers)
            this.clearMarkers();
        this.directionsService.route({
            origin: this.getPoint(option.dep.longitude, option.dep.latitude),
            destination: this.getPoint(option.des.longitude, option.des.latitude),
            waypoints: option.waypoints ? option.waypoints.map(function (p) {
                return {
                    location: thiz.getPoint(p.longitude, p.latitude),
                    stopover: true,
                };
            }) : null,
            travelMode: google.maps.TravelMode[option.model || 'DRIVING']
        }, function (response, status) {
            // console.log(response)
            if (status == 'OK') {
                thiz.directionsDisplay.setDirections(response);
                callback && callback({
                    distance: response.routes[0].legs[0].distance.value,
                    duration: response.routes[0].legs[0].duration.value / 60,
                });
            } else {
                // window.alert('Directions request failed due to ' + status);
                callback && callback();
            }
        });
    }

    /*  返回多点之间的距离和时间
        @dep:[{lng,lat},...]
        @des:[{lng,lat},...]
    */
    distancematrix(options, callback) {
        let service = new google.maps.DistanceMatrixService();
        let thiz = this;
        let time_gap = localStorage.getItem('_distancematrix_time') || 0;
        //更新频率5分钟
        // if(time_gap && (time_gap - Date.now())/1000/60 < 5)return;
        localStorage.setItem('_distancematrix_time', Date.now());
        service.getDistanceMatrix({
            origins: options.dep.map(function (v) {
                return thiz.getPoint(v.longitude, v.latitude);
            }),
            destinations: options.des.map(function (v) {
                return thiz.getPoint(v.longitude, v.latitude);
            }),
            travelMode: 'DRIVING'
        }, function (res, status) {
            if (status) callback(res.rows[0] && res.rows[0].elements[0] && res.rows[0].elements[0]);
        })
    }

    //
}

export default {
    name: 'irmap',
    props: {
        type: {
            default: 'auto',
            type: String
        },
        disabled: {
            default: false,
            type: Boolean
        },
        debug: {
            default: false,
            type: Boolean
        },
    },
    data() {
        return {
            id: 'map-' + nextId(),
            status: this.$t("初始化中..."),
            reloadbtn: null,
            searchText: '', // 搜索文本
            searchResults: [], // 搜索结果
        }
    },
    mounted() {
        this.$nextTick(function () {
            var thiz = this;
            var map = null;
            try {
                if (this.type == 'gmap')
                    map = new GoogleMap(this.id);
                else if (this.type == 'bmap')
                    map = new BaiduMap(this.id);
                else if (window.google && window.google.maps && window.google.maps.Map)
                    map = new GoogleMap(this.id);
                else
                    map = new BaiduMap(this.id);
            }
            catch (e) {
                this.status = this.$t("初始化失败！");
                this.reloadbtn = this.$t("重新加载");
                return;
            }

            var data = map.defaultData;
            this.map = map;
            map.centerAndZoom(data.center_lng, data.center_lat, data.zoom);
            this.map.setDisabled(this.disabled);

            // for test
            if (this.debug) {
                window.map = this.map;
                map.addEventListener('dragend', function (lng, lat, zoom) {
                    console.log(map.getStatus());
                    thiz.$emit('dragend', [lng, lat, zoom])
                });
                map.addEventListener('center_changed', function (lng, lat, zoom) {
                    console.log(map.getStatus());
                    thiz.$emit('dragend', [lng, lat, zoom])
                });
                map.addEventListener('bounds_changed', function (lng, lat, zoom) {
                    console.log(map.getStatus());
                    thiz.$emit('dragend', [lng, lat, zoom])
                });

                map.addEventListener('click', function (e) {
                    thiz.map.addMarker(e.lng, e.lat);
                });

                var mk1 = map.addMarker(data.center_lng, data.center_lat);
                map.addMarker(data.center_lng + 0.08, data.center_lat + 0.08);

                // setTimeout(function(){
                //   mk1.remove()
                // }, 2000);

                // setTimeout(function(){
                //   map.clearMarkers();
                // }, 4000);

                map.displayRoute({
                    dep: { longitude: data.center_lng, latitude: data.center_lat },
                    des: { longitude: data.center_lng + 0.08, latitude: data.center_lat + 0.08 },
                })

                console.log('map debug');
            }
            // end for test

            thiz.$emit('mounted');
        });
    },
    methods: {
        centerAndZoom(lng, lat) {
            // 移动中心点
            this.map.centerAndZoom(lng, lat)
        },
        forceReload() {
            window.location.reload()
        },
        searchLocation() {
            if (!this.searchText.trim()) return;

            const thiz = this;
            this.searchResults = [];
            this.status = this.$t("搜索中...");

            this.map.geocode({
                address: this.searchText
            }, function (results) {
                thiz.status = '';
                if (results && results.length) {
                    thiz.searchResults = results;

                    // 如果有结果，自动定位到第一个结果
                    const firstResult = results[0];
                    const [lng, lat] = firstResult.location;
                    thiz.map.centerAndZoom(lng, lat, thiz.map.getZoom() || 16);

                    // 添加标记 - 简化版
                    thiz.map.clearMarkers();
                    thiz.map.addMarker(lng, lat);  // 只需要经纬度
                    console.log('8888',{lng,lat});
                    
                   thiz.$emit('location-selected', {lng,lat});
                    // });
                } else {
                    thiz.status = thiz.$t("未找到结果");
                }
            });
        },

        // 选择搜索结果
        selectSearchResult(result) {
            this.map.centerAndZoom(
                result.location[0],
                result.location[1],
                this.map.getZoom() || 16
            );
            this.searchText = result.address;
            this.searchResults = [];
        },
    },
    watch: {
        disabled: function (cur, old) {
            this.map.setDisabled(cur);
        }
    }
}
</script>

<style lang="scss">
.map {
    background: white; // #cecece;
    width: 100%;
    height: 100%;
    position: relative;

    >.status {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        justify-items: center;

        div {
            text-align: center;

            span {}
        }
    }
}

.search-box {
    position: absolute;
    top: 10px;
    left: 10px;
    z-index: 1000;
    background: white;
    padding: 5px;
    border-radius: 3px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);

    input {
        padding: 5px;
        border: 1px solid #ccc;
        border-radius: 3px;
        width: 200px;
    }

    button {
        padding: 5px 10px;
        background: #1E90FF;
        color: white;
        border: none;
        border-radius: 3px;
        margin-left: 5px;
        cursor: pointer;
    }

    .search-results {
        margin-top: 5px;
        max-height: 300px;
        overflow-y: auto;
        border: 1px solid #ccc;
        border-radius: 3px;

        div {
            padding: 5px;
            cursor: pointer;

            &:hover {
                background: #f0f0f0;
            }
        }
    }
}
</style>
